import Dropzone from 'dropzone'
import $ from 'jquery'

Dropzone.autodiscover = false

var pluginName = 'giantDropzone',
    dataPrefix = 'dropzone',
    $window = $(window),
    defaults = {
        url: '',
        thumbnailWidth: null,
        thumbnailHeight: null,
        uploadMultiple: true,
        addRemoveLinks: false,
        acceptedFiles: 'image/*',
        template: '.dropzone-template',
        clickable: '.dropzone-area',
        target: null,
    }

function Plugin(element, options) {
    this.scope = element
    this.$scope = $(element)

    this.options = $.extend({}, defaults, options)

    this._defaults = defaults
    this._name = pluginName

    this.init()
}

Plugin.prototype = {
    init: function () {
        var self = this

        if (!this.options.url) {
            this.options.url =
                $('main').data('dropzone-url') ||
                $(document.body).data('dropzone-url') ||
                window.location.href
        }

        if (this.options.template) {
            var template = this.scope.querySelector(this.options.template)
            this.options.previewTemplate = template.innerHTML
            template.parentNode.removeChild(template)
        }

        if (this.options.target && typeof this.options.target === 'string') {
            this.options.target = this.scope.querySelector(this.options.target)
        }

        // console.log('dropzone plugin not implemented');
        // return;

        this.attach()

        return this
    },

    attach: function () {
        var self = this

        var image = this.$scope.find('img')[0]

        if (image) {
            this.options.thumbnailWidth = this.options.thumbnailWidth || image.width
            this.options.thumbnailHeight = this.options.thumbnailHeight || image.height
        }

        var options = $.extend({}, this.options, {
            init: function () {
                var counter = 0

                this.on('drop', function (event) {
                    counter = 0
                })

                this.on('success', function (file, response) {
                    if (!Array.isArray(response)) {
                        response = [response]
                    }

                    response
                        .filter((item) => item.name === file.name)
                        .forEach((item) => {
                            if ('id' in item) {
                                file.previewElement.setAttribute('data-id', item.id)
                            }

                            if ('thumbnail' in item) {
                                file.previewElement.querySelector('img').src = item.thumbnail
                            }

                            if ('remove' in item) {
                                file.previewElement.querySelector('a.btn-danger').href = item.remove
                            }

                            var inputs = $(file.previewElement).find('[data-name-mask]').toArray()
                            inputs.forEach(
                                (input) =>
                                    (input.name = $.substitute(input.dataset.nameMask, {
                                        id: item.id,
                                    })),
                            )
                        })
                })

                this.on('addedfile', function (file) {
                    if (self.options.target) {
                        self.options.target.appendChild(file.previewElement)
                    }
                })
            },
        })

        this.$scope.dropzone(options)
    },

    detach: function () {},
}

$.fn[pluginName] = function (options) {
    var dataPrefixLength = dataPrefix.length

    return this.each(function () {
        if (!$.data(this, 'plugin-' + pluginName)) {
            // parse data-options
            var data = $(this).data(),
                options = {},
                settings = ''

            if (dataPrefix in data) {
                settings = data[dataPrefix]
                // pass options
                if (typeof settings === 'object') {
                    options = settings
                }
            }

            // pass all options to plugin
            $.each(data, function (key, value) {
                if (key.substr(0, dataPrefixLength) === dataPrefix && key !== dataPrefix) {
                    var id = key.substr(dataPrefixLength)
                    id = id.substr(0, 1).toLowerCase() + id.substr(1)
                    options[id] = value
                }
            })

            $.data(this, 'plugin-' + pluginName, new Plugin(this, options))
        }
    })
}

$.fn[pluginName].defaults = defaults

// listen to change event and init self
$(document).on('dom:change', function (event) {
    $('[data-dropzone]', event.target).giantDropzone()
})
$('[data-dropzone]').giantDropzone()
